<rt-report-parameters
    [controlNames]="controlNames"
    (getReport)="onGetReportClick($event)"
    (cancelReport)="onCancelClick()"
>
</rt-report-parameters>
<!-- <div class="container-fluid">
    <div class="col-12" [formGroup]="reportForm">
        <div class="row">
            <div class="col-2">
                <div class="dx-field-label">Trip Close Begin Date</div>
                <dx-date-box
                    name="startDate"
                    formControlName="startDate"
                    class="w-100 bds-dx-custom-material"
                    [stylingMode]="dxMatStyle"
                    type="date"
                    displayFormat="MM/dd/yy"
                    label="MM/dd/yy"
                    [showClearButton]="true"
                    [useMaskBehavior]="true"
                >
                </dx-date-box>
            </div>
            <div class="col-2">
                <div class="dx-field-label">Trip Close End Date</div>
                <dx-date-box
                    name="endDate"
                    formControlName="endDate"
                    class="w-100 bds-dx-custom-material"
                    [stylingMode]="dxMatStyle"
                    type="date"
                    displayFormat="MM/dd/yy"
                    label="MM/dd/yy" 
                    [showClearButton]="true"
                    [useMaskBehavior]="true"                   
                >
                </dx-date-box>
            </div>
            <div class="col-1">
                <button mat-button class="text-uppercase" color="accent" (click)="onGetReportClick()">
                Get Report
                </button>
            </div>
            <div class="col-1">
                <button mat-button class="text-uppercase" color="accent" (click)="onCancelClick()">
                Cancel
                </button>
            </div>
        </div>
    </div>
</div> -->
<div *ngIf="displayReport">
    <div class="container-fluid">
        <bds-fastrac-design-display
            [gridId]="gridId"
            [fastracId]="fastracId"
            [showFastrac]="showFastrac"
            [showGrouping]="true"
            (showFastracChange)="onFastracVisibleChanged($event)"
            (fastracIdChange)="onFastracIdChanged($event)"
            (fastracDesignsChange)="onFastracDesignsChanged($event)"
            (applyFastrac)="onApplyFastrac($event)"
        >
        </bds-fastrac-design-display>
    </div>

    <div class="railroad-grid-container">
        <bds-fastrac-dx-grid-wrapper
            [dataSource]="gridSource"
            [selectedRowKeys]="selectedRowKeys"
            [gridId]="gridId"
            (bdsShowFastrac)="onShowFastrac()"
            (fastracIdChange)="onGridFastracIdChanged($event)"
            [bdsFastracDesignList]="fastracList"
            [fastracDesign]="currentFastrac"
            [fastracId]="fastracId"
            [bdsCustomizeColumns]="customizeColumns"
            [selectionMode]="gridMode"
            [bdsAllowGrouping]="true"
        >
        </bds-fastrac-dx-grid-wrapper>
    </div>
</div>
